export default "__VITE_ASSET__e2ac6149__"